import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/PageHero';
import useReveal from '../hooks/useReveal';
import { aboutPage } from '../mock';

const About = () => {
  const ref = useReveal();
  const p = aboutPage;
  return (
    <div ref={ref}>
      <PageHero eyebrow={p.hero.eyebrow} title={p.hero.title} image={p.hero.image} />

      {/* TILGANG / NARRATIV */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4 reveal">
            <p className="text-[11px] uppercase tracking-[0.3em] text-stone">{p.approach.eyebrow}</p>
            <h2 className="mt-5 font-serif font-light text-3xl md:text-4xl leading-tight">
              {p.approach.title}
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6 reveal">
            <div className="space-y-7 text-base md:text-lg font-light leading-relaxed text-ink/80">
              {p.approach.paragraphs.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PRINCIPPER */}
      <section className="bg-paper border-y border-ink/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32">
          <div className="reveal mb-14 max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.3em] text-stone">{p.principles.eyebrow}</p>
            <h2 className="mt-5 font-serif font-light text-4xl md:text-5xl">{p.principles.title}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
            {p.principles.items.map((v) => (
              <div key={v.title} className="reveal">
                <div className="h-px w-12 bg-ink/30" />
                <h3 className="mt-6 font-serif text-2xl font-light">{v.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-stone">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUOTE + CTA */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="img-hover-zoom aspect-[4/5] reveal">
            <img src={p.quote.image} alt="Fagligt arbejde" className="h-full w-full object-cover" />
          </div>
          <div className="reveal">
            <p className="font-serif font-light text-3xl md:text-4xl leading-[1.35]">{p.quote.text}</p>
            <Link
              to={p.quote.ctaPath}
              className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] border-b border-ink/50 pb-1 hover:border-ink transition-colors"
            >
              {p.quote.ctaLabel} <ArrowRight size={14} strokeWidth={1.4} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
